import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '~src/httpClient/RestApiService';

import { IScimConfig, IUpdateScimConfigRequest, IUpdateScimConfigResponse } from '../service/ScimConfigService';

export function updateScimConfigRequestConfig(scimConfig: IScimConfig): JsonRestApiRequestConfig {
  return {
    restApiVersion: '3.27',
    httpMethod: 'PUT',
    endpoint: `scimConfig/${scimConfig.id}`,
    serverWideRequest: false
  };
}

export function callUpdateScimConfigRequest(scimConfig: IScimConfig): Promise<IUpdateScimConfigResponse> {
  return makeJsonRestApiRequest<IUpdateScimConfigRequest, IUpdateScimConfigResponse>({
    config: updateScimConfigRequestConfig(scimConfig),
    request: {
        createServerScimConfigRequestForUpdate: {
        isEnabled: scimConfig.isEnabled,
        authentication: scimConfig.authentication,
        authenticationId: scimConfig.authenticationId
      }
    },
  });
}